import { Box, Typography } from "@mui/material";
import ReusableInfoModal from "../../General/ReusableInfoModal/ReusableInfoModal";

const DriverInfoModal = ({
  id,
  open,
  onClose,
}: {
  id: string;
  open: boolean;
  onClose: () => void;
}) => {
  return (
    <ReusableInfoModal
      endpoint="getDriverById"
      entityId={id}
      open={open}
      onClose={onClose}
      title="Driver Information"
      renderData={(driver) => (
        <Box>
          <Typography>
            Full name: {driver.firstName} {driver.lastName}
          </Typography>
          <Typography>Phone number: {driver.phoneNumber}</Typography>
          <Typography>Company: {driver.company}</Typography>
          <Typography>Driver code: {driver.driverCode}</Typography>
          <Typography>Type: {driver.driverType}</Typography>
          <Typography>Pay to: {driver.payTo}</Typography>
        </Box>
      )}
    />
  );
};

export default DriverInfoModal;
